import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../Services/authentication.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) {}
    public licenseExpiredMessage: string = '';
    private static licenseAlertShown = false;

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (err.status === 401) {
                // Only log out + reload on a real session loss — otherwise a cleared
                // localStorage causes every retry to 401 again, looping forever.
                const hadSession = !!localStorage.getItem('currentUser');
                if (hadSession) {
                    this.authenticationService.logout();
                    location.reload(true);
                }
                const error = (err.error && err.error.message) || err.statusText;
                return throwError(error);
            }
            else if (err.status === 0) {
                // Connection-level failure — not proof the session is invalid, so no logout/reload.
                return throwError(err.statusText || 'Network error — please check your connection and try again.');
            }
            else if (err.status === 403) {
                if(err.error.includes('License has expired for user') && !window.location.pathname.includes('/login')){
                    if (!ErrorInterceptor.licenseAlertShown) {
                        ErrorInterceptor.licenseAlertShown = true;
                        this.licenseExpiredMessage = 'License has expired. Please renew your license.';
                        alert(this.licenseExpiredMessage);
                        this.authenticationService.logout();
                        location.reload();
                        }
                    const error = err.error;
                    return throwError(error);
                } 
                else {
                    this.authenticationService.logout();
                    const error = err.error;
                    return throwError(error);
                }
            } 
            else if (err.status === 404) {
                return throwError(err);
            } 
            else {
                const body = err.error;
                let message = err.statusText;
                if (typeof body === 'string' && body.trim()) {
                    message = body;
                } else if (body && typeof body === 'object') {
                    message = body.operationMessage
                        || (typeof body.data === 'string' ? body.data : null)
                        || body.message
                        || err.statusText;
                }
                return throwError(message);
            }
        }))
    }
}